import { createTheme as createThemeV4 } from '@material-ui/core/styles';
import { createTheme as createThemeV5 } from '@mui/material/styles';
import {defaultColor, ecoColor, customPalette, mysticNightColor, skyColor, sunnyColor} from '../styling/Colors'
import { Typography } from './Typography'

const colorSelect = localStorage.getItem('colorSelect')
const fontSelect = localStorage.getItem('fontSelect')


let palette

switch(colorSelect){
    case 'Sky':
        palette = skyColor
        break
    case 'Sunny':
        palette = sunnyColor
        break
    case 'Eco':
        palette = ecoColor
        break
    case 'Mystic Night':
        palette = mysticNightColor
        break
    case 'Custom':
        palette = customPalette
        break
    default:
        palette = defaultColor
}

const breakpoints = {
    values: {
        xs: 0,
        sm: 750,
        md: 900,
        lg: 1200,
        xl: 1536,
    },
}

const fontFamily = () => {
    switch(fontSelect){
        case 'Roboto':
            return '\'Roboto\', sans-serif'
        case 'Open Sans':
            return '\'Open Sans\', sans-serif'
        case 'Segoe UI':
            return '\'Segoe UI\', sans-serif'
        default:
            return '\'Montserrat\', sans-serif'
    }
}

const boxShadow = '0px 0px 6px #00000029'

const themeOptions = {
    palette,
    breakpoints,
    boxShadow,
    fontFamily: fontFamily(),
    typography: Typography,
}

export const themeV4 = createThemeV4(themeOptions)
export const themeV5 = createThemeV5(themeOptions)
